import React from "react";
import { formatAssignmentStatus } from "../../utils/formatAssignmentStatus";
import useStatusColors from "../../hooks/useStatusColors";

// Work booked for the day without a start time. The hourly grids position
// tasks by scheduledStartTime, which is only set when someone picks a time, so
// these are listed separately rather than left off the day entirely.
export default function UnscheduledTaskList({ tasks, onOpen }) {
  const { getStatusStyle } = useStatusColors();
  if (!tasks.length) return null;

  return (
    <div className="unscheduled-list">
      {tasks.map((task) => {
        const statusStyle = getStatusStyle(task.status, task.slaPercentage);
        const statusInfo = formatAssignmentStatus(task.status);
        return (
          <button
            key={task.id}
            type="button"
            className="unscheduled-chip"
            style={{
              backgroundColor: statusStyle.backgroundColor,
              borderLeftColor: statusStyle.borderColor,
            }}
            onClick={() => onOpen?.(task)}
            title={`${task.stageName || "Task"} - ${task.projectName || "Project"} · ${statusInfo.label} · no start time set`}
          >
            <span
              className="unscheduled-chip-project"
              style={{ color: statusStyle.textColor }}
            >
              {task.projectName || "Untitled Project"}
            </span>
            <span className="unscheduled-chip-stage">
              {task.stageName || "Task"}
            </span>
          </button>
        );
      })}
    </div>
  );
}
